export const api =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:8080/Roberto/CRM/CRM-SERVER/'
        : 'https://crm.sisprecisa.com.br/server/'
